import { ComponentReport } from './component_report';
import { AccuracyDriversTable } from '../content/accuracy_drivers_table';
import { MarketplaceIdToLabel } from '../const/dropdown_elements';
import { ReportSummary } from './components/report_summary';
import { ColumnSetSelector } from './components/columnset_selector';
import { REPORT_TYPE } from '../../constants/report_type';
import { findColumnSetItems } from './utils/report_preferences';

/**
 * A container component that encapsulates the different sections
 * displayed on the component report page.
 */
export class ComponentReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedColumnSetsByUser: null,
      displayAccuracyDrivers: this.props.displayAccuracyDrivers,
    };

    this.reportData = {};
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.displayAccuracyDrivers !== this.props.displayAccuracyDrivers) {
      // After a report has been loaded, user may change the report filters selections.
      // If the report already loaded has accuracy drivers section displayed,
      // then it shouldn't become hidden based on the new choices made by the user
      // and vice-versa. So this change of `props.displayAccuracyDrivers` is ignored.
      // The `state.displayAccuracyDrivers` in the constructor copies the initial value of
      // `props.displayAccuracyDrivers` and maintains it.
    }
  };

  updateReportData = (reportData) => {
    this.reportData = reportData;
  };

  setColumnSets = (event) => {
    const selectedColumnSetsByUser = event.detail.selectedOptions.map((op) => op.value);
    const selectionChanged = selectedColumnSetsByUser !== this.state.selectedColumnSetsByUser;

    if (selectionChanged) {
      this.setState({ selectedColumnSetsByUser });
      this.props.onSelectedColumnSetsChanged(selectedColumnSetsByUser);
    }
  };

  savePreferences = (selectedColumnSets) => {
    const { columnsJson } = this.props;

    const columnSetItems = findColumnSetItems(columnsJson, selectedColumnSets, REPORT_TYPE.COMPONENT);
    const columns = [...new Set((columnSetItems || []).map((s) => s.columns).flat())];

    this.props.savePreferences(columns, columnSetItems);
  };

  render() {
    return (
      <div>
        <div>
          <ReportSummary
            loading={this.props.loading}
            responsePayloads={this.props.responsePayloads}
            reportData={this.reportData}
            summaryMapKeys={this.props.summaryMapKeys}
          />
        </div>

        <div>
          {this.state.displayAccuracyDrivers && (
            <AccuracyDriversTable
              payload={this.props.payload}
              featureList={this.props.featureList}
              marketplaceIdToLabel={MarketplaceIdToLabel}
            />
          )}
        </div>

        <div style={{ marginTop: '1em', marginBottom: '1em' }}>
          <ColumnSetSelector
            placeholder="Benchmark Selection"
            columnSets={this.props.columnsJson.componentSets}
            selectedColumnSets={this.state.selectedColumnSetsByUser || this.props.selectedColumnSets}
            onChange={this.setColumnSets}
          />
        </div>

        <div>
          <ComponentReport
            updateReportData={this.updateReportData}
            selectedColumnSetsByUser={this.state.selectedColumnSetsByUser}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/component_report_container.js